<template>
  <v-dialog persistent v-model="extraClassDialog" max-width="60rem">
    <v-card>
      <v-card-title
        >Select the slots of extra classes you want to create</v-card-title
      >
      <v-form ref="form" v-model="extraClassValidation.valid">
        <!-- <v-card-text>
            <v-container>
              <v-text-field
                v-model="editedClassRoom.extraClass"
                type="number"
                label="No of Classes"
                :rules="extraClassValidation.noOfClassesRules"
                required
              ></v-text-field>
            </v-container>
          </v-card-text> -->
        <v-container fluid>
          <TeacherAvailabilityCalender
            :startDate="startDate"
            :selectedTeacherId="editedClassRoom.teacherId"
            :teachers="teachers"
            :extraClass="true"
            @update-selected-slots="handleSelectedSlots"
          />
        </v-container>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="closeExtraClassDialog()"
          >Cancel</v-btn
        >
        <v-btn color="primary" text @click="extraClass()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  BASE_URL,
  EXTRA_CLASS,
  GET_ALL_TEACHER_AVAILABILITY,
  GET_ALL_CLASS_OPERATIONS,
} from "@/common/apiEndpoints";
import { SET_API_SUCCESS, SET_OVERLAY_VALUE } from "@/store/mutations";
import { mapGetters, mapMutations } from "vuex";
import axios from "axios";
import { getAxiosOptions } from "@/common/utility";
import { GET_TOKEN } from "@/store/getters";
import TeacherAvailabilityCalender from "../TeacherAvailabilityCalender.vue";

export default {
  components: {
    TeacherAvailabilityCalender,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      extraClassDialog: false,
      extraClassValidation: {
        valid: false,
        noOfClassesRules: [
          (v) => !!v || "This is required",
          (v) => Number(1) <= v || "No of classes must be greater than 0",
        ],
      },
      selectedSlots: [],
      startDate: "",
      teachers: [],
      editedClassRoom: {
        classRoomId: "",
        teacherId: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      token: `schoolModule/${GET_TOKEN}`,
    }),
  },
  methods: {
    ...mapMutations({
      setApiSuccess: `schoolModule/${SET_API_SUCCESS}`,
      setOverlayValue: `schoolModule/${SET_OVERLAY_VALUE}`,
    }),

    handleSelectedSlots(newSelectedSlots) {
      this.selectedSlots = newSelectedSlots;
    },

    openExtraClassDialog(classRoomItem) {
      this.getAllClassOps(classRoomItem.classRoomId);
      this.getTeacherAvailability();
      this.extraClassDialog = true;
      this.editedClassRoom.classRoomId = classRoomItem.classRoomId;
      this.editedClassRoom.teacherId = classRoomItem.teacherInfo.teacherId;
    },

    closeExtraClassDialog() {
      this.extraClassDialog = false;
    },

    extraClass() {
      this.$refs.form.validate();
      if (this.extraClassValidation.valid) {
        const payload = {};
        payload.classRoomId = this.editedClassRoom.classRoomId;
        payload.schedule = this.selectedSlots.map((slot) => {
          return {
            startDateTime: slot.startDateTime,
            endDateTime: slot.endDateTime,
          };
        });
        let url = EXTRA_CLASS;
        this.setOverlayValue(true);
        axios
          .post(url, payload, getAxiosOptions(BASE_URL, this.token))
          .then((res) => {
            this.extraClassValidation.valid = false;
            this.closeExtraClassDialog();
            this.setApiSuccess("Extra Class created Successfully");
            this.setOverlayValue(false);
            this.$emit("extra-class-created");
          })
          .catch((error) => {
            error = error.errorMessage;
            this.closeExtraClassDialog();
            this.setOverlayValue(false);
          });
      }
    },

    getAllClassOps(classRoomId) {
      let url = GET_ALL_CLASS_OPERATIONS;
      let payload = {};
      payload.classRoomId = classRoomId;
      axios
        .post(url, payload, getAxiosOptions(BASE_URL, this.token))
        .then((res) => {
          let lastOperation =
            res.data.classOperations[res.data.classOperations.length - 1];
          const startDateTime = new Date(lastOperation.classInfo.startDateTime);
          startDateTime.setDate(startDateTime.getDate() + 1);
          const today = new Date();

          // Check if startDateTime is in the past
          if (startDateTime < today) {
            this.startDate = today.toISOString().substr(0, 10);
          } else {
            this.startDate = startDateTime.toISOString().substr(0, 10);
          }
        })
        .catch((error) => {
          error = error.errorMessage;
        });
    },

    getTeacherAvailability() {
      let url = GET_ALL_TEACHER_AVAILABILITY;
      axios
        .get(url, getAxiosOptions(BASE_URL, this.token))
        .then((res) => {
          this.teachers = res.data.teachers;
        })
        .catch((error) => {
          error = error.errorMessage;
        });
    },
  },
};
</script>